import React from 'react'
import './DisplaySelfReturn'
import Config from '../../../../../Config'
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import { connect } from 'react-redux';

function DisplaySelfReturn(props) {

    function reportGA() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_SELF_CARE_CENTER_PRODUCT_PAGE.category, gaParams.DISCONNECT_CLICK_ON_SELF_CARE_CENTER_PRODUCT_PAGE.eventType, props.serviceToDisconnect.serviceType)
    }

    return (
        <div className="self-container">
            <h4 className="self-header">מרכזי השירות שלנו לרשותך להחזרה עצמית של הציוד</h4>
            <a className="pink-link" target="_blank" href={Config.cellcomServiceCenters} onClick={reportGA}>
                לרשימת נקודות החזרה 
                <div className="arrow"/>
            </a>
        </div>
    )
}


const mapStateToProps = (state) => ({
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect
});

export default connect(mapStateToProps, null)(DisplaySelfReturn);